import React from "react";

// Single source of truth for the DAILY RESET / by Maayaveda hierarchy.
// "Daily Reset" is the primary brand; "by Maayaveda" is the secondary.
// Variants:
//   xl   → splash / welcome / auth
//   lg   → headers, section banners
//   md   → cards, footer signatures
//   sm   → tiny chips, settings rows
export default function Brand({
  variant = "lg",
  align = "center",
  className = "",
  primaryColor = "#1A2E24",
  accentColor = "#D6336C",
}) {
  const sizes = {
    xl: { primary: "text-5xl sm:text-6xl tracking-tight", secondary: "text-sm tracking-[0.32em]" },
    lg: { primary: "text-3xl sm:text-4xl tracking-tight",  secondary: "text-[11px] tracking-[0.28em]" },
    md: { primary: "text-2xl tracking-tight",              secondary: "text-[10px] tracking-[0.26em]" },
    sm: { primary: "text-lg tracking-tight",               secondary: "text-[9px] tracking-[0.24em]"  },
  }[variant] || { primary: "text-3xl", secondary: "text-xs" };

  const alignCls = align === "left" ? "items-start text-left" : align === "right" ? "items-end text-right" : "items-center text-center";

  return (
    <div className={`flex flex-col gap-1 ${alignCls} ${className}`} data-testid="brand-lockup">
      <p
        className={`font-medium ${sizes.primary} leading-none`}
        style={{ fontFamily: "Outfit, sans-serif", color: primaryColor }}
        data-testid="brand-primary"
      >
        DAILY RESET
      </p>
      <p
        className={`uppercase font-semibold ${sizes.secondary}`}
        style={{ color: accentColor, fontFamily: "Outfit, sans-serif" }}
        data-testid="brand-secondary"
      >
        by Maayaveda
      </p>
    </div>
  );
}
